import React from "react";
import { FileDown } from "lucide-react";

export const DownloadButton = ({ url, label, filename = "warehouse-coffee.pdf", variant = "dark", testId }) => {
  if (!url) return null;
  const cls = variant === "dark"
    ? "border-forest bg-forest text-offwhite hover:bg-forest-dark"
    : "border-forest/25 bg-white text-forest hover:bg-forest/5";
  return (
    <a
      href={url}
      download={filename}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border px-6 py-3 font-display text-xs font-bold uppercase tracking-wider transition-all ${cls}`}
    >
      <FileDown className="h-4 w-4" /> {label}
    </a>
  );
};

export default DownloadButton;
